<template>
  <div class="newHome _1s5o_Nurot9f8UDOzXmtj8">
    <div class="_2w06rfANEKjXheNYYzo_la container">
      <h1 style="text-align: center; padding-bottom: 50px">
        <span>服务项目</span>
      </h1>
      <div class="_255rapQMNJ8XL8hNX4cL3m">
        <div class="_3z0aUvqTtPX9piYQI4-lAB">
          <h2
            style="
              color: #091930;
              padding-bottom: 8px;
              letter-spacing: 2px;
              font-size: 22px;
            "
          >
            区块链快速存证
          </h2>
          <p style="color: #475663; line-height: 1.8; padding-top: 10px; font-size: 14px;font-family: PingFangSC-Regular;">
            区块链版权存证：基于版权区块链的存证，利用区块链技术替代传统版权存证方式，针对作品进行时间戳认定，即时生成存证证书，做司法认可的版权区块链认证。
          </p>
          <div class="_1cNeDz9Z_-cULlXKDkrPqP">
            <router-link to="/ExistingEvidence/InputForm">前往存证</router-link>
          </div>
        </div>
        <div class="_3B1lHaA5XOI2YWYZNDkjxe">
          <h2
            style="
              color: #091930;
              padding-bottom: 8px;
              letter-spacing: 2px;
              font-size: 22px;
            "
          >
            版权局官方登记
          </h2>
          <p style="color: #475663; line-height: 1.8; padding-top: 10px; font-size: 14px;font-family: PingFangSC-Regular;">
            湖北版权局官方授权：湖北省数字版权综合服务平台，直连湖北省版权保护中心，权威可信，打破线下冗余流程，节省时间成本，最大化提高登记效率，获得同等权威作品登记证书权益。
          </p>
          <div class="_1cNeDz9Z_-cULlXKDkrPqP">
            <router-link to="/Register/InputForm">前往登记</router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="_14fu9Yln_gUQKjxU2AuNeG">
      <h1 style="text-align: center; padding: 50px 0">
        <span>平台优势</span>
      </h1>
      <div class="sInfoCon1_1">
        <div class="featureBox container">
          <div class="featureContent">
            <div class="featureText">
              <div>
                <img
              src="../assets/images/home-img03.png"
              alt=""
            />
              </div>
              <p class="title">上链确权存证</p>
              <p class="content">采用区块链技术，提供原创作品存证保护服务</p>
            </div>
          </div>
          <div class="featureContent">
            <div class="featureText">
              <div>
                <img
              src="../assets/images/home-img04.png"
              alt=""
            />
              </div>
              <p class="title">全网侵权检测</p>
              <p class="content">
                依托大数据区块链文字监测技术，精准定位侵权线索
              </p>
            </div>
          </div>
          <div class="featureContent">
            <div class="featureText">
              <div>
                <img
              src="../assets/images/home-img05.png"
              alt=""
            />
              </div>
              <p class="title">作品侵权可查</p>
              <p class="content">原创作品可实时溯源查证</p>
            </div>
          </div>
        </div>
        <div class="featureBox container">
          <div class="featureContent">
            <div class="featureText">
              <div>
                 <img
                src="../assets/images/home-img06.png"
                alt=""
              />
              </div>
              <p class="title">在线智能签约</p>
              <p class="content">提供智能合约，快速签署，利益分成</p>
            </div>
          </div>
          <div class="featureContent">
            <div class="featureText">
              <div>
                <img
                src="../assets/images/home-img07.png"
                alt=""
              />
              </div>
              <p class="title">权威部门合作</p>
              <p class="content">最高人民法院中国行为法学会合作</p>
            </div>
          </div>
          <div class="featureContent">
            <div class="featureText">
              <div>
                <img
                src="../assets/images/home-img08.png"
                alt=""
              />
              </div>
              <p class="title">专业团队协助</p>
              <p class="content">
                专业技术团队与执行团队协作，高效存取、合理维权
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="_3trYIBs509mmmITAdZ0aIK">
        <div class="_4-ZF3Np2VyyQsrUO4ysv0"></div>
        <div style="position: absolute; width: 230px; top: 80px; left: 190px">
          <h2
            style="
              color: #3377fe;
              text-align: right;
              padding-bottom: 10px;
            "
          >
            安全专业
          </h2>
          <p>区块链+可信时间戳双重技术，随时随地上链存证，可溯源、防篡改</p>
        </div>
        <div style="position: absolute; width: 230px; top: 320px; left: 190px">
          <h2
            style="
              color: #3377fe;
              text-align: right;
              padding-bottom: 10px;
            "
          >
            司法认证
          </h2>
          <p>区块链存证证书已作为新型电子证据被司法部门采信。</p>
        </div>
        <div style="position: absolute; width: 230px; top: 80px; right: 190px">
          <h2 style="color: #3377fe; padding-bottom: 10px">
            高效便捷
          </h2>
          <p>24小时线上快速登记，一键确权，操作简便，效率高</p>
        </div>
        <div style="position: absolute; width: 230px; top: 320px; right: 190px">
          <h2 style="color: #3377fe; padding-bottom: 10px">
            双证保障
          </h2>
          <p>版权登记证书+版权存证证书一份消费两份保障</p>
        </div>
      </div> -->
    </div>
    <div class="lBwiLNMW6EmycW1iVqBK9 container">
      <h1 style="text-align: center; padding-bottom: 50px">
        <span>服务对象</span>
      </h1>
      <ul class="_3VsFSo8d_Rp15mS0kx-wwg">
        <li>
          <div >
            <h2>
              原创机构
            </h2>
            <img
            src="../assets/images/home-img11.png"
          />
            <p>
              报社、杂志社、原创作品网站，教育机构等能在知识产权领域有所应用原创的机构
            </p>
          </div>
        </li>
        <li>
          <div >
            <h2>
              原创作者
            </h2>
            <img
            src="../assets/images/home-img12.png"
          />
            <p>
              文章作者、原创个体等用户，根据需要定制各种不同种类的区块链行业应用
            </p>
          </div>
        </li>
        <li>
          <div >
            <h2>
              企业自媒体
            </h2>
            <img
            src="../assets/images/home-img13.png"
          />
            <p>
              微信、微博、头条号等媒体账号运营者，企业号运营者等自媒体建立成果确权及保护
            </p>
          </div>
        </li>
        <li>
          <div >
            <h2>
              政府单位
            </h2>
            <img
            src="../assets/images/home-img14.png"
          />
            <p>
              各级行政单位和事业单位等相关机构对信息的管理及监测
            </p>
          </div>
        </li>
      </ul>
    </div>

    <div class="copy-box">
      <div class="container-lg">
        <h1 style="text-align: center; padding: 0 0px 20px 0">
          <span>平台保障</span>
          <p>区块链全网AI智能检索监控存证，AI知识图谱搜索引擎，去中心化内容溯源和筛选机制实现内容的存储、检索、版权保护和知识传播</p>
        </h1>
        <div class="container">
          <ul>
            <li>
              <div><img src="../assets/images/home-img15.png" alt=""><span>核心技术</span></div>
              <p>原创作品存证保护，一经写入，不可篡改，完成版权溯源</p>
            </li>
            <li>
              <div><img src="../assets/images/home-img16.png" alt=""><span>实时监控</span></div>
              <p>大数据监控、智能合约约束，完成存取、溯源、利益分成闭环</p>
            </li>
            <li>
              <div><img src="../assets/images/home-img17.png" alt=""><span>智能取证</span></div>
              <p>全网AI智能检索监控存证，去中心化内容溯源和筛选机制实现内容的存储取证</p>
            </li>
            <li>
              <div><img src="../assets/images/home-img18.png" alt=""><span>法律维护</span></div>
              <p>最高人民法院中国行为法学会合作，最高人民法院向全国推广</p>
            </li>
          </ul>
          <img src="../assets/images/home-img19.png" alt="" class="copy-box-img">
        </div>
      </div>
    </div>

    <div class="_2drZqKp6_uR_mYJER65yEo">
      <div class="container">
        <h1 style="text-align: center; padding-bottom: 50px">
          <span>新闻资讯</span>
        </h1>
        <ul class="_1abxkYP_Oh6eiYcdWW0CcM">
          <li class="_27WOUp-Ca37sm-zGAzdIn0"
          v-for="(item,index) in newsList"
          :key="index"
          @click="onEditOrder(item)">
            <div style="width: 100%; height: 186px; overflow: hidden">
              <img :src="item.img" width="100%">
            </div>
            <p class="_3_BZ-al9sw-Fk-LMzYgjxa">{{item.tittle}}</p>
            <p class="eLekIQIk2itpaznsOKyyM">{{item.desc}}</p>
            <p class="_3thcUZyBWTfkeVS-zPCrxw">
              <span style="float: left">{{item.time}}</span>
            </p>
          </li>
        </ul>
      </div>

      <!--新增入库单抽屉-->
    <transition name="slide">
      <input-view
        v-if="isInputDrawerShow"
        :rowData="currentRepairOrderRow"
        class="slide-dialog"
        @dialog-close="onInputDrawerClose"
      />
    </transition>

      <div style="text-align: center; padding-top: 30px">
        <button type="button" class="ant-btn ant-btn-text">
           <router-link to="/NewsList">
           <span>查看更多</span
          ><span
            role="img"
            aria-label="double-right"
            class="anticon anticon-double-right"
            ><svg
              viewBox="64 64 896 896"
              focusable="false"
              data-icon="double-right"
              width="1em"
              height="1em"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                d="M533.2 492.3L277.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H188c-6.7 0-10.4 7.7-6.3 12.9L447.1 512 181.7 851.1A7.98 7.98 0 00188 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5zm304 0L581.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H492c-6.7 0-10.4 7.7-6.3 12.9L751.1 512 485.7 851.1A7.98 7.98 0 00492 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z"
              ></path></svg></span>
           </router-link>
        </button>
      </div>
    </div>

    <div class="LinkBlock">
      <div class="fluid container">
        <div class="topTittle"><h2>合作单位</h2></div>
        <div class="ant-row">
          <div class="ant-col ant-col-md-24 ant-col-lg-6 ant-col-xl-6">
            <div class="block animate__animated animate__fadeInDown">
              <div class="topWrap">
                <div class="logo-link">
                  <img
                    src="../assets/images/huoban01.png"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="ant-col ant-col-md-24 ant-col-lg-6 ant-col-xl-6">
            <div class="block animate__animated animate__fadeInDown">
              <div class="topWrap">
                <div class="logo-link">
                  <img
                    src="../assets/images/huoban02.png"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="ant-col ant-col-md-24 ant-col-lg-6 ant-col-xl-6">
            <div class="block animate__animated animate__fadeInDown">
              <div class="topWrap">
                <div class="logo-link">
                  <img
                    src="../assets/images/huoban03.png"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="ant-col ant-col-md-24 ant-col-lg-6 ant-col-xl-6">
            <div class="block animate__animated animate__fadeInDown">
              <div class="topWrap">
                <div class="logo-link">
                  <img
                    src="../assets/images/huoban04.png"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="padding-bottom: 50px;background: #fff;">
      <img src="../assets/images/support.png" style="display:block;margin: 0 auto;width: 300px;height: auto;" alt="">
    </div>
  </div>
</template>

<script>
import InputView from '../views/NewsDetail/InputView'
export default {
  name: "newHome",
  components: {
    InputView
  },
  data() {
    return {
      // 录入/补录 抽屉显示
      isInputDrawerShow: false,
      // 外修单ID
      currentRepairOrderRow: {},
      newsList: [
        {
          img: 'https://ipchain.oss-cn-hangzhou.aliyuncs.com/web/privateicon/news01.png',
          tittle: '国家级区块链创新应用试点',
          desc: '根据《关于组织申报区块链创新应用试点的通知》（中网办秘字〔2021〕1482号），经过中央网信办、中央宣传部、国务院办公厅[电子政务办公室]、最高人民法院、最高人民检察院、教育部、工业和信息化部、民政部、司法部、人力资源社会保障部、国家卫生健康委、中国人民银行、国家税务总局、中国银保监会、中国证监会、国家能源局、国家外汇管理局等17个中央委办部门和单位严格评审，中国知链获批“国家区块链创新应用试点”。',
          time: '2021-12-22',
          flag: 1,
        },
        {
          img: 'https://ipchain.oss-cn-hangzhou.aliyuncs.com/web/privateicon/news04.png',
          tittle: '湖北省版权保护中心与可信大数据签约共推中国知链项目',
          desc: '3月29日下午，湖北省版权保护中心与可信大数据有限公司举行合作协议签字仪式，共同推进中国知链——国家区块链创新应用试点项目落地湖北并发展壮大。中心主任郑凌辉、可信公司董事长兼总经理胡江南出席签字仪式。',
          time: '2022-03-30',
          from: '来源：湖北省版权保护中心 作者：刘迟 文 / 图 ',
          flag: 2,
        },
        {
          img: 'https://ipchain.oss-cn-hangzhou.aliyuncs.com/web/privateicon/news07.png',
          tittle: '可信大数据有限公司参加武汉市首场数字经济大会',
          desc: '3月31日下午，2022年武汉科技成果转化首场对接活动数字经济专场在武钢体育馆举行。本次会议成果提供方包括华中科技大学、武汉大学、武汉科技大学等一批在汉高校及科研院所，武汉钢铁有限公司、中冶集团武汉勘察研究院有限公司、可信大数据有限公司、黑芝麻智能科技有限公司等一批在汉企业为成果承接方。24个科技成果转化项目，签约总合作金额达3.1亿元以上。',
          time: '2022-04-01',
          flag: 3,
        },
        // {
        //   img: 'https://baikewh.oss-cn-hangzhou.aliyuncs.com/static/ipchain/newImg.png',
        //   tittle: '知链平台简介2',
        //   desc: '段落示意222：蚂蚁金服设计平台 design.alipay.com，用最小的工作量，无缝接入蚂蚁金服生态，提供跨越设计与开发的体验解决方案。蚂蚁金服设计平台 design.alipay.com，用最小的工作量，无缝接入蚂蚁金服生态，提供跨越设计与开发的体验解决方案。',
        //   time: '2017-10-01 18:00'
        // },
      ],
    };
  },
  methods: {
    // 录入/补录 抽屉打开
    onEditOrder(data) {
      console.log("onEditOrder...")
      this.currentRepairOrderRow = data
      this.isInputDrawerShow = true
    },
     // 录入/补录 抽屉关闭
    onInputDrawerClose() {
      this.isInputDrawerShow = false
    },
  },
};
</script>

<style>

h1 {
  font-size: 24px;
  line-height: 32px;
  font-weight: 500;
  color: rgba(3, 3, 3, 0.85);
}
.ant-btn-text,
.ant-btn-text:hover {
  color: rgba(0, 0, 0, 0.85);
  background: transparent;
  border-color: transparent;
  box-shadow: none;
}
.ant-btn-text a{
  text-decoration: none;
}
._1s5o_Nurot9f8UDOzXmtj8 {
  background-color: #fff;
}
._1s5o_Nurot9f8UDOzXmtj8 h1 span {
  /* border-bottom: 2px solid #3377fe; */
  padding: 6px;
  color: #333;
  font-size: 28px;
}
._2w06rfANEKjXheNYYzo_la {
  padding-top: 50px;
  padding-bottom: 50px;
  background-color: #fff;
}
._255rapQMNJ8XL8hNX4cL3m {
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
._3z0aUvqTtPX9piYQI4-lAB {
  width: 48%;
  height: 270px;
  margin: 20px 0;
  padding: 30px;
  padding-left: 240px;
  background: url("../assets/images/newHome01.png") 30px 50px no-repeat;
  background-size: 180px 180px;
  position: relative;
  background-color: #FCFDFF;
  box-shadow: 0px 3px 20px 0px rgba(218, 237, 250, 0.72);
  border-radius: 4px;
}
._3B1lHaA5XOI2YWYZNDkjxe {
  width: 48%;
  height: 270px;
  margin: 20px 0;
  padding: 30px;
  padding-left: 240px;
  background: url("../assets/images/newHome02.png") 30px 50px no-repeat;
  background-size: 180px 180px;
  background-color: #FCFDFF;
  box-shadow: 0px 3px 20px 0px rgba(218, 237, 250, 0.72);
  border-radius: 4px;
  position: relative;
}
._3z0aUvqTtPX9piYQI4-lAB:hover,
._3B1lHaA5XOI2YWYZNDkjxe:hover {
  box-shadow: 0px 3px 20px 0px rgba(208, 227, 240, 1);
}
._1cNeDz9Z_-cULlXKDkrPqP a {
  color: #3377fe;
  position: absolute;
  padding: 5px 20px;
  bottom: 30px;
  left: 240px;
  font-size: 16px;
  cursor: pointer;
  border: 1px solid #3377fe;
  text-decoration: none;
}
._1cNeDz9Z_-cULlXKDkrPqP a:hover {
  color: #fff;
  background: #3377fe;
}

._14fu9Yln_gUQKjxU2AuNeG {
  background-color: #F4F7FC;
  padding-bottom: 50px;
}
._3trYIBs509mmmITAdZ0aIK {
  width: 100%;
  height: 420px;
  margin: 0 auto;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
._4-ZF3Np2VyyQsrUO4ysv0 {
  width: 300px;
  height: 281px;
  background: url(https://www.gzbqdj.com/acb451463cf452d7bd8e2c042dcc06b8.png);
  background-size: 300px 281px;
}

.lBwiLNMW6EmycW1iVqBK9 {
  background-color: #fff;
  padding-top: 50px;
  padding-bottom: 50px;
}
._3VsFSo8d_Rp15mS0kx-wwg {
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
._3VsFSo8d_Rp15mS0kx-wwg li {
  border-radius: 10px;
  box-shadow: 0px 0px 53px 0px rgba(161, 187, 218, 0.2);
  width: 23%;
  height: 278px;
  overflow: hidden;
}
._3VsFSo8d_Rp15mS0kx-wwg li div{
  padding: 20px;
}
._3VsFSo8d_Rp15mS0kx-wwg li div h2{
  font-size: 18px;
  font-weight: normal;
  line-height: 38px;
  text-align: center;
  color: #475663;
}
._3VsFSo8d_Rp15mS0kx-wwg li:hover div h2{
  color: #3377fe;
}
._3VsFSo8d_Rp15mS0kx-wwg li div img{
  width: 78px;
  height: 78px;
  display: block;
  margin: 20px auto;
}
._3VsFSo8d_Rp15mS0kx-wwg li div p{
  font-size: 14px;
  color: #475663;
  line-height: 24px;
  text-align: center;
  font-family: PingFangSC-Regular;
}
._3VsFSo8d_Rp15mS0kx-wwg li:hover {
  box-shadow: 0px 0px 53px 0px rgba(161, 187, 218, 0.39);
}

._1kgGe4_mOhnwG09r93yWdq {
  width: 100%;
  height: 220px;
  margin: 0 auto;
  background: url(https://www.gzbqdj.com/4255d2bea0ed062657c1a15455332527.png)
    100% 100%;
}

._36WVZBFcndO4No22Ey25a- {
  background-color: #ccc;
  position: relative;
}
._16pr-s8oFvc3fWh1EGZ0rR {
}
._16pr-s8oFvc3fWh1EGZ0rR img {
  margin: 0 auto;
  width: 100%;
  max-width: 1920px;
}
._1fnyy0y0_DkkbjdRosNTw6 {
  position: absolute;
  width: 153px;
  height: 153px;
  background-image: url(https://www.gzbqdj.com/d83ec3c0768471b7030630a5c510d5b5.png);
  top: 50%;
  margin-top: -76px;
  left: 5%;
  cursor: pointer;
  z-index: 1;
}
._3X-31zLogEvs_rb7lSIkJv {
  position: absolute;
  width: 153px;
  height: 153px;
  background-image: url(https://www.gzbqdj.com/026cf9c2263aea733242cf3c1bfa1ddc.png);
  top: 50%;
  margin-top: -76px;
  right: 5%;
  cursor: pointer;
  z-index: 1;
}

._2drZqKp6_uR_mYJER65yEo {
  background-color: #F4F7FC;
  padding-top: 50px;
  padding-bottom: 50px;
}
._1abxkYP_Oh6eiYcdWW0CcM {
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
._27WOUp-Ca37sm-zGAzdIn0 {
  position: relative;
  background-color: #fff;
  overflow: hidden;
  cursor: pointer;
  text-decoration: none;
  width: 30%;
  box-shadow: 0px 12px 21px 0px rgba(150, 178, 206, 0.14);
}
._27WOUp-Ca37sm-zGAzdIn0:hover {
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  text-decoration: none;
}
._3_BZ-al9sw-Fk-LMzYgjxa {
  height: 36px;
  line-height: 36px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 10px;
  font-size: 18px;
  color: #091930;
  margin-top: 10px;
}
.eLekIQIk2itpaznsOKyyM {
  padding: 0px 15px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  margin: 10px 0 20px 0;
  color: #475663;
  font-family: PingFangSC-Regular;
}
._3thcUZyBWTfkeVS-zPCrxw {
  padding: 0 15px 20px 15px;
  overflow: hidden;
  color: #475663;
  font-family: PingFangSC-Regular;
}

._2drZqKp6_uR_mYJER65yEo h1 span {
  /* border-bottom: 2px solid #3377fe; */
  padding: 6px;
}

.featureBox {
  display: flex;
  justify-content: space-between;
    align-items: center;
    margin-bottom: 40px;
}
.featureBox .featureContent {
  width: 30%;
  height: 192px;
  display: flex;
  background: #fff;
  padding: 22px 40px;
}
.featureBox .featureContent .featureText div {
  width: 55px;
  height: 55px;
  border-radius: 50%;
}
.featureBox .featureContent .featureText div img {
  width: 100%;
  height: 100%;
}
/* .featureBox .featureContent:hover div{
  background: transparent;
} */
.featureBox .featureContent .featureText .title {
  font-size: 18px;
  font-weight: 400;
  color: #091930;
  line-height: 38px;
  margin-top: 10px;
}
.featureBox .featureContent .featureText .content {
  font-size: 14px;
  color: #475663;
  line-height: 20px;
  font-family: PingFangSC-Regular;
}
/* .featureBox .featureContent:hover {
  background: #3377fe;
}
.featureBox .featureContent:hover .featureText .title {
  color: #fff;
}
.featureBox .featureContent:hover .featureText .content {
  color: #fff;
} */

.copy-box {
  position: relative;
  padding: 50px 0 72px 0;
}
.copy-box h1 p{
  line-height: 50px;
  font-size: 14px;
  color: #475663;
  font-family: PingFangSC-Regular;
}
.copy-box .container{
  background: #FEFEFE;
  box-shadow: 0px 2px 50px -4px rgba(90, 141, 227, 0.17);
  border-radius: 16px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
    align-items: center;
}
.copy-box .container ul{
  display: block;
  width: 60%;
}
.copy-box .container ul li{
  width: 50%;
  height: 154px;
  float: left;
}
.copy-box .container ul li div{display: flex;margin: 20px 0 10px 0;}
.copy-box .container ul li div img{
  width: 33px;
  height: 33px;
  margin-right: 5px;
}
.copy-box .container ul li div span{
  font-size: 18px;
  color: #112435;
}
.copy-box .container ul li p{
  font-size: 14px;
  color: #475663;
  padding: 0 38px;
  line-height: 26px;
  font-family: PingFangSC-Regular;
}
.copy-box .container .copy-box-img{
  width: 35%;
  height: 308px;
}
.knowledge-swiper {
  position: relative;
  height: 207px;
}
.mt15 {
  margin-top: 15px !important;
}
.swiper-container {
  margin: 0 auto;
  position: relative;
  overflow: hidden;
  list-style: none;
  padding: 0;
  z-index: 1;
}
.swiper-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  transition-property: -webkit-transform;
  transition-property: transform;
  transition-property: transform, -webkit-transform;
  box-sizing: content-box;
}
.swiper-slide {
  -ms-flex-negative: 0;
  -webkit-flex-shrink: 0;
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  position: relative;
  transition-property: -webkit-transform;
  transition-property: transform;
  transition-property: transform, -webkit-transform;
}
.hand-cover {
  cursor: pointer !important;
}
.fadeIn {
  -webkit-animation-name: fadeIn;
  animation-name: fadeIn;
}
.animated {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
.images-auto {
  background: 50% no-repeat;
  background-size: cover;
}
.knowledge-swiper .title {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  line-height: 50px;
  text-align: center;
  font-size: 20px;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.7);
}
.swiper-button-next,
.swiper-button-prev {
  position: absolute;
  top: 50%;
  width: 27px;
  height: 44px;
  margin-top: -22px;
  z-index: 10;
  cursor: pointer;
  background-size: 27px 44px;
  background-position: 50%;
  background-repeat: no-repeat;
}
.swiper-button-next,
.swiper-container-rtl .swiper-button-prev {
  right: 10px;
  left: auto;
}
.knowledge-swiper .swiper-button-next,
.knowledge-swiper .swiper-button-prev {
  background-image: none;
  width: 52px;
  height: 52px;
  margin-top: -26px;
  outline: none;
}
.knowledge-swiper .swiper-button-next .icon,
.knowledge-swiper .swiper-button-prev .icon {
  font-size: 50px;
  font-weight: bold;
}
.swiper-button-next.swiper-button-disabled,
.swiper-button-prev.swiper-button-disabled {
  opacity: 0.35;
  cursor: auto;
  pointer-events: none;
}

.LinkBlock {
  background: #fff;
  background-size: 100% auto;
  padding: 72px 0;
}
.LinkBlock .topTittle {
  text-align: center;
  margin-bottom: 24px;
}
.LinkBlock .topTittle h2 {
  display: inline-block;
  font-size: 28px;
  text-align: center;
  padding: 6px 0px;
  /* border-bottom: 2px solid #3377fe; */
  color: #333;
}
.ant-row {
  position: relative;
  height: auto;
  margin-right: 0;
  margin-left: 0;
  zoom: 1;
  display: block;
  box-sizing: border-box;
}
.fluid .ant-col-xl-6,
.fluid .ant-col-lg-12,
.fluid .ant-col-xl-8 {
  padding: 16px;
}
.LinkBlock .block {
  height: 120px;
  background: #FFFFFF;
  box-shadow: 0px 0px 18px 0px rgba(35, 71, 137, 0.1);
  position: relative;
  overflow: hidden;
}
.LinkBlock .logo-link img {
  height: 80px;
  position: relative;
  left: 50%;
  top: 20px;
  transform: translate(-50%);
}

@media screen and (max-width: 991px) {
  ._130sYBNHWax9YtgUgIsm1Z .container-l{z-index: 1;}
  ._130sYBNHWax9YtgUgIsm1Z .container .container-l h1{font-size: 30px!important;text-align: center!important;}
  ._130sYBNHWax9YtgUgIsm1Z .container img{width: 80%;height: auto!important;position: absolute;right: 0;top: 20%;z-index: 0;}
  ._255rapQMNJ8XL8hNX4cL3m{display: block;}
  ._3z0aUvqTtPX9piYQI4-lAB,._3B1lHaA5XOI2YWYZNDkjxe{width: 100%;padding-left: 30px;}
  ._1cNeDz9Z_-cULlXKDkrPqP a{left: 200px;}
  .featureBox{display: block;}
  .featureBox .featureContent{width: 100%;}
  ._3VsFSo8d_Rp15mS0kx-wwg{display: block;}
  ._3VsFSo8d_Rp15mS0kx-wwg li{width: 100%;}
  .copy-box h1 p{line-height: 26px;padding: 0 20px;}
  .copy-box .container .copy-box-img{display: none;}
  .copy-box .container ul{width: 100%;z-index: 1;}
  .copy-box .container ul li{width: 100%;}
  ._1abxkYP_Oh6eiYcdWW0CcM{display: block;}
  ._27WOUp-Ca37sm-zGAzdIn0{width: 100%;margin-bottom: 20px;}
  

}
</style>
